import {
    CircularProgress, Backdrop, type BackdropProps, NoSsr,
} from '@mui/material';

export type BackdropSpinnerProps = BackdropProps & {
    open?: boolean
    onClose?: () => void
}

const BackdropSpinner = ({ open, onClose, ...rest }: BackdropSpinnerProps): JSX.Element => <NoSsr>
    {open ? <Backdrop open={open} onClick={onClose} {...rest} sx={{ zIndex: 2000 }}>
        {open && <CircularProgress color="secondary" />}
    </Backdrop> : null}
</NoSsr>;

export default BackdropSpinner;
